// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"16858041","782":"e5dc0ce3"}[chunkId] + ".chunk.css";
};